import { Spinner } from '@frontend/components/common';
import React from 'react';

export interface DefaultGhostButtonProps {
    text: React.ReactNode;
    onClick: () => void;
    disabled?: boolean;
    isLoading?: boolean;
    dataTestId?: string;
}

export const DefaultGhostButton = (props: DefaultGhostButtonProps) => {
    return (
        <button
            disabled={props.disabled || props.isLoading}
            onClick={props.onClick}
            data-testid={props.dataTestId ?? 'ghost-button'}
            className='hover:bg-brand-light text-brand-primary disabled:text-brand-disabled disabled:hover:text-brand-disabled hover:text-brand-secondary inline-flex cursor-pointer items-center justify-center gap-2.5 rounded-xl px-4 py-3 disabled:cursor-not-allowed disabled:hover:bg-inherit'>
            <div className='flex content-center items-center justify-center gap-2 text-base font-medium'>
                {props.isLoading && <Spinner className='size-4 text-border-default fill-brand-primary' />}
                {props.text}
            </div>
        </button>
    );
};
